import React, { useState, useEffect, forwardRef, useRef } from 'react';
import _ from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDockListCommonFunc } from './Common/FetchDockList'
import { toast } from 'react-toastify';
import { changeFormatWithoutTz, showAlert } from '../../../../../../Assests/Utility';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { changeDateToGivenFormat, getCurrentDate, getDockOperationalTime } from '../../../../../../../Utils/DateUtils';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getWhMetaDataReducerSlice } from '../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import moment from 'moment';
import './Docks.css';
import SSPopup from '../../../../../Common/Popup/SSPopup/SSPopup';
import WarehouseSearchSS from '../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import DockListSS from './DockList/DockListSS';
import { useNavigate } from 'react-router-dom';
import CustomFieldWithTtileSS from '../../../../../Common/CustomField/CustomFieldWithTtileSS';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';
import { getRemoteConfigSelector } from '../../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import { tooltip } from 'aws-amplify';
import CustomTooltip from '../../../../../Common/Tooltip/CustomTooltip';
import { SketchPicker } from 'react-color';
import AutomaticCancelPopup from '../Common/AutomaticCancelPopup';

/**
 * Initial Error state
 */
const initialErrors = {
    DockName: '',
    PPH: '',
    CPH: '',
    TPH: '',
    TPM: '',
    operational_days: '',
    StartTime: '',
    EndTime: '',
    CapacityModeling: '',
    BlockHours: '',
    appointmentLifeTime: '',
    appointmentLeadTime: '',
    showReasonCodeWindow: '',
    showReasonCodeWindowPost: '',
    ApptFrequency: '',
    DockAppointmentCompletionConfig: '',
    AppointmentCancelationType: '',
    AppointmentDueDateType: '',
    ScheduleOutsideWindow: '',
    OverdueBookingAllowed: '',
    DockColorCode: '',
    NoShowAllowedStatus: '',
    NoShowHours: ''
}

const DocksSS = (props) => {
    const { themeSelected, editGroupAction, allowPermissionE = true, allowPermissionD, whObj } = props;
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [searchStr, setSearchStr] = useState('');
    const [loading, setLoading] = useState(false);
    const [startTimeState, setStartTimeState] = useState('');
    const [endTimeState, setEndTimeState] = useState('');
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { operationObj, preCheckList, dockTypeList, whMetaDocksList } = whMetaData;
    const user = useSelector(getUserSelector);
    const { cu_id, selectedWarehouse } = user;
    const [showPreCheckModal, setShowPreCheckModal] = useState(false);
    const [showAutomaticCancelConfirmPopup, setShowAutomaticCancelConfirmPopup] = useState(false);
    const [pendingDockData, setPendingDockData] = useState(null);
    const [showAutoMassCancelNotification, setShowAutoMassCancelNotification] = useState(false);
    const firstUpdate = useRef(true);
    const navigate = useNavigate()
    const [unSlectedDays, setUnSelectedDays] = useState('');
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const [capacityModalObject, setCapacityModalObject] = useState({})
    const [dockListType, setDockListType] = useState(null)
    const { allConfigration } = remoteConfig;

    const [inputs, setInputs] = useState({
        DockName: "",
        PPH: "",
        CPH: "",
        TPH: "",
        TPM: "",
        operational_days: null,
        StartTime: "",
        EndTime: "",
        CapacityModeling: "",
        BlockHours: "",
        appointmentLifeTime: "",
        appointmentLeadTime: "",
        showReasonCodeWindow: "",
        showReasonCodeWindowPost: "",
        ApptFrequency: "",
        DockAppointmentCompletionConfig: "AUTOMATIC",
        AppointmentCancelationType: "MANUAL",
        AppointmentDueDateType: "PARENTPO",
        ScheduleOutsideWindow: "",
        OverdueBookingAllowed: false,
        DockColorCode: "",
        NoShowAllowedStatus: false,
        NoShowHours: 0
    })
    
    const [errors, setErrors] = useState(initialErrors)

    const [dirty, setDirty] = useState({
        DockName: false,
        PPH: false,
        CPH: false,
        TPH: false,
        TPM: false,
        operational_days: false,
        StartTime: false,
        EndTime: false,
        CapacityModeling: false,
        BlockHours: false,
        appointmentLifeTime: false,
        appointmentLeadTime: false,
        showReasonCodeWindow: false,
        showReasonCodeWindowPost: false,
        ApptFrequency: false,
        AppointmentCancelationType: false,
        AppointmentDueDateType: false,
        ScheduleOutsideWindow: false,
        OverdueBookingAllowed: false,
        DockColorCode: false,
        NoShowAllowedStatus: false,
        NoShowHours: false
    })
    
    const [operationalDays, setOperationalDays] = useState({
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false
    })

    useEffect(() => {
        if (inputs.OverdueBookingAllowed === true || inputs.OverdueBookingAllowed === 'true') {
            const lifeTime = (inputs.ScheduleOutsideWindow || 0) * 24;
            setInputs(prev => ({ ...prev, appointmentLifeTime: lifeTime }));
        } else {
            setInputs(prev => ({ ...prev, appointmentLifeTime: 0, ScheduleOutsideWindow: "" }));
        }
    }, [inputs.ScheduleOutsideWindow, inputs.OverdueBookingAllowed]);

    useEffect(() => {
        return () => {
            dispatch({ type: sagaActions.RESET_MASS_CANCEL_REASON });
        }
    }, []);

    const fetchDockTypeList = () => {
        const apiParams = {
            "IDWarehouse": selectedWarehouse.ID,
            "DockType": null,
            "CRUDTYPE": "S",
            "CreatedDate": null,
            "CreatedBy": null,
            "UpdatedDate": null,
            "UpdatedBy": null,
            "Status": null,
            "Deleted": null,
        }

        const operationObj = {
            type: 'Fetch dock type',
            status: '',
        }
        dispatch({ type: sagaActions.DOCK_TYPE_LIST_ACTION, payload: apiParams, operationObj: operationObj });

    }
    /**
     * useEffect to form capacity model object 
     */
    useEffect(() => {
        if (allConfigration && allConfigration.CapacityModels) {
            let obj = {};
            JSON.parse(allConfigration.CapacityModels).forEach((el) => {
                obj[el.name] = el.description
            })
            setCapacityModalObject(obj)
        }
        fetchDockTypeList()
    }, [allConfigration])

    useEffect(() => {
        if (dockTypeList.length) {
            let nArray = []
            dockTypeList.forEach((el, i) => {
                let objDockList = {};
                objDockList.dockName = el.DockType;
                objDockList.id = el.ID;
                nArray.push(objDockList)
            })
            setDockListType(nArray)
        } else {
            setDockListType([])
        }
    }, [dockTypeList])


    /**
     * Function to handle change in form 
     * @param {*} data 
     * @param {*} name 
     * @param {*} control 
     */
    let handleChange = (data, name) => {
        if (name === "OverdueBookingAllowed" || name === "NoShowAllowedStatus") {
            data = data === 'true';
        } else if (typeof data === 'object') {
            data = data.toString();
        }


        getFormFieldData && getFormFieldData(data, name);
        setInputs((inputs) => ({ ...inputs, [name]: data }));

    };

    /**
     * Function to get Number by week day name
     * @param {*} name 
     * @returns 
     */
    const getWeekDayNumber = (name) => {
        switch (name) {
            case 'sunday':
                return '1'
                break;
            case 'monday':
                return '2'
                break;
            case 'tuesday':
                return '3'
                break;
            case 'wednesday':
                return '4'
                break;
            case 'thursday':
                return '5'
                break;
            case 'friday':
                return '6'
                break;
            case 'saturday':
                return '7'
                break;
            default:
                break;
        }
    }

    /**
     * Function to handle change in operational days
     * @param {*} e 
     */
    let handleOperationalDays = (e) => {

        const { name, checked } = e.target;
        let obj = { ...inputs.operational_days, [name]: checked }
        if (!checked) {
            setUnSelectedDays((prev) => prev + ',' + getWeekDayNumber(name))
        }
        setOperationalDays((operationalDays) => ({ ...operationalDays, [name]: checked }))
        setInputs(inputs => ({ ...inputs, operational_days: obj }))
    }

    /**
     * Function to handle errors
     * @param {*} name 
     */
    const handleErrors = (name) => {
        setDirty((dirty) => ({ ...dirty, [name]: true }));
        validate(name);
    };

    /**
     * Function to validate form inputs
     * @param {*} name 
     * @returns 
     */
    const validate = (name) => {
        let valid = true
        let errorData = { ...initialErrors }
        if (!inputs.DockName) {
            errorData.DockName = AppConstant.help.required
            valid = false
        }
        if (inputs.CapacityModeling && inputs.CapacityModeling === 'TPH') {
            if (!inputs.TPH) {
                errorData.TPH = AppConstant.help.required;
                valid = false
            } else if (parseInt(inputs.TPH) <= 0) {
                errorData.TPH = "Trucks per hour must be greater than 0";
                valid = false
            }
        }
        if (inputs.CapacityModeling && inputs.CapacityModeling === 'TPM') {
            if (!inputs.TPH) {
                errorData.TPH = AppConstant.help.required;
                valid = false
            } else if (parseInt(inputs.TPH) <= 0) {
                errorData.TPH = "Trucks must be greater than 0";
                valid = false
            }
            if (!inputs.TPM) {
                errorData.TPM = AppConstant.help.required;
                valid = false
            } else if (parseInt(inputs.TPM) <= 0) {
                errorData.TPM = "Duration must be greater than 0";
                valid = false
            }
        }
        if (inputs.CapacityModeling && inputs.CapacityModeling === 'Productivity') {
            if (!inputs.CPH) {
                errorData.CPH = AppConstant.help.required;
                valid = false
            } else if (parseInt(inputs.CPH) <= 0) {
                errorData.CPH = "Cases Per Hour must be greater than 0";
                valid = false
            }
            if (!inputs.PPH) {
                errorData.PPH = AppConstant.help.required;
                valid = false
            } else if (parseInt(inputs.PPH) <= 0) {
                errorData.PPH = "Pallets Per Hour must be greater than 0";
                valid = false
            }
        }
        if (!inputs.StartTime) {
            errorData.StartTime = AppConstant.help.required
            valid = false
        }
        if (!inputs.EndTime) {
            errorData.EndTime = AppConstant.help.required
            valid = false
        }
        if (!inputs.CapacityModeling) {
            errorData.CapacityModeling = AppConstant.help.required
            valid = false
        }
        if (!inputs.operational_days || !validateOperationalDays(inputs?.operational_days)) {
            errorData.operational_days = AppConstant.help.required
            valid = false
        }
        if (inputs.BlockHours) {
            let maxBlockMin = allConfigration.MaxBlockHours ? (allConfigration.MaxBlockHours * 60) : (30 * 60);
            if (inputs.BlockHours < 0) {
                errorData.BlockHours = "Block Time should be grater than 0";
                valid = false
            } else if (inputs.BlockHours > maxBlockMin) {
                errorData.BlockHours = `Block Time should be less than ${maxBlockMin} min (${maxBlockMin / 60}hr)`;
                valid = false
            }

        }
        if (inputs.appointmentLeadTime) {
            let maxAppointmentLeadTime = allConfigration.MaxAppointmentLeadTime ? (allConfigration.MaxAppointmentLeadTime) : (2880);
            if (parseInt(inputs.appointmentLeadTime) < 0) {
                errorData.appointmentLeadTime = "Appointment Lead Time should be grater than 0";
                valid = false
            } else if (parseInt(inputs.appointmentLeadTime) > parseInt(maxAppointmentLeadTime)) {
                errorData.appointmentLeadTime = `Appointment Lead Time should be less than ${maxAppointmentLeadTime} hr`;
                valid = false
            }

        }
        if (inputs.showReasonCodeWindow) {
            if (parseInt(inputs.showReasonCodeWindow) < 0) {
                errorData.showReasonCodeWindow = "Show Reason Code Window Before DueDate";
                valid = false
            }
        }
        if (inputs.showReasonCodeWindowPost) {
            if (parseInt(inputs.showReasonCodeWindowPost) < 0) {
                errorData.showReasonCodeWindowPost = "Show Reason Code Window Post DueDate";
                valid = false
            }
        }
        if (inputs.appointmentLeadTime && inputs.showReasonCodeWindow) {
            if (inputs.showReasonCodeWindow > inputs.appointmentLeadTime/24) {
                errorData.showReasonCodeWindow = "Show Reason Code Window Should Be Less Than Appointment Lead Time";
                valid = false
            }
        }

        if (inputs.ScheduleOutsideWindow && inputs.showReasonCodeWindowPost) {
            if (parseInt(inputs.showReasonCodeWindowPost ) > parseInt(inputs.ScheduleOutsideWindow)) {
                errorData.showReasonCodeWindowPost = "Show Reason Code Window Should Be Less Than Schedule Outside Window";
                valid = false
            }
        }


        if (inputs.NoShowAllowedStatus && !inputs.NoShowHours) {
            errorData.NoShowHours = AppConstant.help.required;
            valid = false;
        } else if (inputs.NoShowHours) {
            if (!Number.isInteger(Number(inputs.NoShowHours))) {
                errorData.NoShowHours = "Only integers are allowed";
                valid = false
            } else if (parseInt(inputs.NoShowHours) < 0) {
                errorData.NoShowHours = "Value cannot be negative";
                valid = false
            }
        }
        if (!inputs.ApptFrequency) {
            errorData.ApptFrequency = AppConstant.help.required
            valid = false
        }
        if (inputs.OverdueBookingAllowed && !inputs.ScheduleOutsideWindow) {
            errorData.ScheduleOutsideWindow = AppConstant.help.required;
            valid = false;
        } else if (inputs.ScheduleOutsideWindow) {
            if (!Number.isInteger(Number(inputs.ScheduleOutsideWindow))) {
                errorData.ScheduleOutsideWindow = "Only integers are allowed";
                valid = false
            } else if (parseInt(inputs.ScheduleOutsideWindow) > 365) {
                errorData.ScheduleOutsideWindow = "Value cannot be greater than 365";
                valid = false
            } else if (parseInt(inputs.ScheduleOutsideWindow) < 0) {
                errorData.ScheduleOutsideWindow = "Value cannot be negative";
                valid = false
            }
        }
        // if (!inputs.DockAppointmentCompletionConfig) {
        //     errorData.DockAppointmentCompletionConfig = AppConstant.help.required
        //     valid = false
        // }
        setErrors(errorData)
        return valid
    }

    // const preferedDocksList = dockListType.sort((a, b) => a.dockName.localeCompare(b.dockName));

    useEffect(() => {
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] })
        setLoading(false);
        setShowModal(false);
        setShowAutoMassCancelNotification(false);
    }, [])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if (preCheckList.length > 0) {
            setShowModal(false)
            setLoading(false);
            // For edit dock config flow, pendingDockData holds the submitted inputs;
            // check AppointmentCancelationType directly from the submitted data first,
            // then fall back to looking it up in the existing dock list.
            const submittedCancelationType = pendingDockData?.apiParams?.AppointmentCancelationType;
            const selectedDockId = pendingDockData?.apiParams?.ID;
            const selectedDock = whMetaDocksList.find(dock => dock.ID === selectedDockId);
            const cancelationType = submittedCancelationType || selectedDock?.AppointmentCancelationType;
            if (cancelationType === 'AUTOMATIC') {
                setShowAutomaticCancelConfirmPopup(true);
            } else {
                setShowPreCheckModal(true);
            }
        }
    }, [preCheckList])

    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Create Dock':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.docks.createDockSuccess, showAutoMassCancelNotification);
                    } else {
                        // Use specific error message from backend if available
                        const errorMessage = operationObj.errorMessage || AppConstant.smartScheduler.docks.createDockFailure;
                        handleApiResponse(AppConstant.commonStrings.failure, errorMessage, showAutoMassCancelNotification);
                    }
                    break;
                case 'Edit Dock':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.docks.updateDockStatusSuccess, showAutoMassCancelNotification);
                    } else {
                        // Use specific error message from backend if available
                        const errorMessage = operationObj.errorMessage || AppConstant.smartScheduler.docks.updateDockFailure;
                        handleApiResponse(AppConstant.commonStrings.failure, errorMessage, showAutoMassCancelNotification);
                    }
                    break;
                case 'Update status':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.docks.updateDockStatusSuccess,showAutoMassCancelNotification);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.docks.updateDockStatusFailure,showAutoMassCancelNotification );
                    }
                    break;
                default:
            }
        }
    }, [operationObj])

    const handleApiResponse = (result, message, showAutoMassCancelNotification) => {
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            setShowModal(false)
            fetchDockList()
            if (showAutoMassCancelNotification) {
                showAlert(toast.TYPE.INFO, AppConstant.smartScheduler.leaves.massCancellationNotification, themeSelected);
                setShowAutoMassCancelNotification(false)
            }
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        setLoading(false)
        setUnSelectedDays("")
        setPendingDockData(null);
        dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
    }

    const fetchDockList = () => {
        const { apiParams, operationObj } = fetchDockListCommonFunc(whObj);
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj })
    }

    const TUSDatePickerInput = forwardRef(({ value, titleField, onClick }, ref) => {
        if (titleField === 'Start') {
            return (
                <button className="customDatePickerInput-ss" onClick={onClick} ref={ref}>
                    {particularFieldValue && particularFieldValue.StartTime ? particularFieldValue.StartTime : 'HH:MM'}
                </button>
            )
        } else if (titleField === 'End') {
            return (
                <button className="customDatePickerInput-ss" onClick={onClick} ref={ref}>
                    {particularFieldValue && particularFieldValue.EndTime ? particularFieldValue.EndTime : 'HH:MM'}
                </button>
            )
        }
    })

    const filterPassedTimeValue = (time) => {
        return moment(startTimeState, "HH:mm").isBefore(moment(time, "HH:mm"))
    };

    const editDock = (data) => {
console.log("edit dock : ", data);
        const editData1 = {
            "DockName": data.Name,
            "PPH": data.PPH,
            "TPH": data?.TPH,
            "CPH": data?.CPH,
            "TPM": data?.TPM,
            "DockStatus": data.DockStatus,
            "ID": data.ID,
            "CRUDTYPE": "U",
            "IDWarehouse": data.IDWarehouse,
            "StartTime": changeFormatWithoutTz(data.StartTime, 'HH:mm'),
            "EndTime": changeFormatWithoutTz(data.EndTime, 'HH:mm'),
            "CreatedOn": data.CreatedDate,
            "operational_days": {
                sunday: data.sunday,
                monday: data.monday,
                tuesday: data.tuesday,
                wednesday: data.wednesday,
                thursday: data.thursday,
                friday: data.friday,
                saturday: data.saturday
            },
            "BlockHours": data?.BlockHours,
            "CapacityModeling": data?.CapacityModeling,
            "appointmentLifeTime": data?.ApptLifeTime,
            "appointmentLeadTime": data?.ApptLeadTime,
            "showReasonCodeWindow": data?.ShowReasonCodeWindow,
            "showReasonCodeWindowPost": data?.ShowReasonCodeWindowPost,
            "ApptFrequency": data?.ApptFrequency,
            "DockAppointmentCompletionConfig": data?.DockAppointmentCompletionConfig,
            "AppointmentCancelationType": data?.AppointmentCancelationType,
            "AppointmentDueDateType": data?.AppointmentDueDateType,
            "ScheduleOutsideWindow": data?.OverdueBookingAllowedDays,
            "OverdueBookingAllowed": data?.OverdueBookingAllowed,
            "DockColorCode": data?.DockColorCode || "",
            "NoShowAllowedStatus": data?.NoShowAllowedStatus || false,
            "NoShowHours": data?.NoShowHours || 0
        }
        setShowModal(true);
        setEditData(editData1);
        setInputs(editData1)
        setStartTimeState(changeFormatWithoutTz(data.StartTime, 'HH:mm'));
        setEndTimeState(changeFormatWithoutTz(data.EndTime, 'HH:mm'));
        setParticularFieldValue({
            ...editData1,
            'StartTime': changeFormatWithoutTz(data.StartTime, 'HH:mm'),
            'EndTime': changeFormatWithoutTz(data.EndTime, 'HH:mm')
        });
    }

    const getDockList = () => {
        return dockListType.map((ele, index) => {
            return (
                <option key={ele.id} value={ele.dockName}>
                    {ele.dockName}
                </option>
            );
        })
    }
    

    const getDockApptFrequency = () => {
        if (allConfigration && allConfigration.ApptFrequency) {
            return JSON.parse(allConfigration.ApptFrequency).map((ele, index) => {
                return (
                    <option key={ele} value={ele}>
                        {ele}
                    </option>
                );
            })
        }
    }

    /**
     * Component to render color picker using react-color
     * @returns JSX
     */
    const ColorPickerField = () => {
        const [showPicker, setShowPicker] = useState(false);

        const handleColorChange = (color) => {
            handleChange(color.hex, 'DockColorCode');
        };

        return (
            <div className="color-picker-field" style={{ marginBottom: '15px' }}>
                <label className="form-label" style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Dock Color
                </label>
                <div style={{ position: 'relative' }}>
                    <div
                        onClick={() => setShowPicker(!showPicker)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '8px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            backgroundColor: themeSelected === AppConstant.commonStrings.lightModeFilterString ? '#fff' : '#2d2d2d',
                            cursor: 'pointer'
                        }}
                    >
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '4px',
                            backgroundColor: inputs.DockColorCode || '#ffffff',
                            border: '2px solid #666'
                        }}></div>
                        <span style={{ flex: 1, fontSize: '14px' }}>
                            {inputs.DockColorCode ? 'Color selected' : 'Click to select a color'}
                        </span>
                        {inputs.DockColorCode && (
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleChange('', 'DockColorCode');
                                }}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '0 5px',
                                    fontSize: '20px',
                                    color: '#999'
                                }}
                                title="Clear color"
                            >
                                ×
                            </button>
                        )}
                    </div>
                    {showPicker && (
                        <div style={{
                            position: 'absolute',
                            zIndex: 2,
                            marginTop: '8px'
                        }}>
                            <div
                                style={{
                                    position: 'fixed',
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                }}
                                onClick={() => setShowPicker(false)}
                            />
                            <SketchPicker
                                color={inputs.DockColorCode || '#ffffff'}
                                onChange={handleColorChange}
                                onChangeComplete={handleColorChange}
                            />
                        </div>
                    )}
                </div>
                {dirty['DockColorCode'] && errors['DockColorCode'] && (
                    <span className="errorMessage" style={{ fontSize: '12px', color: '#dc3545', marginTop: '5px', display: 'block' }}>
                        {errors['DockColorCode']}
                    </span>
                )}
            </div>
        );
    };

    const getFormFieldData = (data, name) => {
        if (name === 'StartTime') {
            setInputs({ ...inputs, StartTime: changeDateToGivenFormat(data, 'HH:mm') })
            setStartTimeState(changeDateToGivenFormat(data, 'HH:mm'));
            setEndTimeState('');
            setParticularFieldValue({
                // ...particularFieldValue,
                'StartTime': changeDateToGivenFormat(data, 'HH:mm'),
                'EndTime': particularFieldValue.EndTime ? particularFieldValue.EndTime : ""
            });
        } else if (name === 'EndTime') {
            setInputs({ ...inputs, EndTime: changeDateToGivenFormat(data, 'HH:mm') })
            setParticularFieldValue({
                ...particularFieldValue,
                'EndTime': changeDateToGivenFormat(data, 'HH:mm')
            });
            setEndTimeState(changeDateToGivenFormat(data, 'HH:mm'));
        }
    };

    /**
     * Function to render option for Capacity model select dropdown
     * @param {*} data 
     * @returns JSX 
     */
    const getCapacityModelingList = (data) => {
        return data?.map((el) => {
            return (
                <option key={el.name} value={el.name}>
                    {`${el.name === 'TPM' ? 'TPD' : el.name} (${el.description})`}
                </option>
            )
        })
    }

    /**
     * Function to render form
     * @returns 
     */
    const createForm = () => {
        return (
            <div className='d-flex flex-column gap-2'>
                <CustomFieldWithTtileSS
                    type={"select"}
                    showError={
                        dirty["DockName"] && errors["DockName"][0]
                            ? errors["DockName"]
                            : ""
                    }
                    name={"DockName"}
                    value={inputs["DockName"] ? inputs["DockName"] : ""}
                    handleErrors={handleErrors}
                    title={"Dock Type"}
                    required={true}
                    onChange={(data, name) => handleChange(data, name)}
                    listData={getDockList}
                    disabledField={Object.keys(editData).length ? true : false}
                />
                <CustomFieldWithTtileSS
                    type={'select'}
                    showError={dirty["CapacityModeling"] && errors["CapacityModeling"] ? errors["CapacityModeling"] : ""}
                    name='CapacityModeling'
                    listData={() => allConfigration && allConfigration.CapacityModels && getCapacityModelingList(JSON.parse(allConfigration.CapacityModels))}
                    value={inputs.CapacityModeling ? inputs.CapacityModeling : ""}
                    handleErrors={handleErrors}
                    title='Capacity Model'
                    required={true}
                    onChange={(data, name) => handleChange(data, name)}
                    className={"f-14"}
                />
                {inputs.CapacityModeling && inputs.CapacityModeling === 'TPH' &&
                    <CustomFieldWithTtileSS
                        type={"number"}
                        showError={dirty["TPH"] && errors["TPH"][0] ? errors["TPH"] : ""}
                        name={"TPH"}
                        value={inputs["TPH"] ? inputs["TPH"] : ""}
                        handleErrors={handleErrors}
                        title={capacityModalObject[inputs.CapacityModeling]}
                        required={true}
                        onChange={(data, name) => handleChange(data, name)}
                    />
                }
                {inputs.CapacityModeling && inputs.CapacityModeling === 'TPM' &&
                    <div className='d-flex gap-2'>
                        <div className='flex-fill'>
                            <CustomFieldWithTtileSS
                                type={"number"}
                                showError={dirty["TPH"] && errors["TPH"][0] ? errors["TPH"] : ""}
                                name={"TPH"}
                                value={inputs["TPH"] ? inputs["TPH"] : ""}
                                handleErrors={handleErrors}
                                title={'Trucks'}
                                required={true}
                                onChange={(data, name) => handleChange(data, name)}
                            />
                        </div>
                        <div className='flex-fill'>
                            <CustomFieldWithTtileSS
                                type={"number"}
                                showError={dirty["TPM"] && errors["TPM"][0] ? errors["TPM"] : ""}
                                name={"TPM"}
                                value={inputs["TPM"] ? inputs["TPM"] : ""}
                                handleErrors={handleErrors}
                                title={'Duration(min)'}
                                required={true}
                                onChange={(data, name) => handleChange(data, name)}
                            />
                        </div>
                    </div>
                }
                {inputs.CapacityModeling && inputs.CapacityModeling === 'Productivity' &&
                    <>
                        <CustomFieldWithTtileSS
                            type={"number"}
                            showError={dirty["CPH"] && errors["CPH"][0] ? errors["CPH"] : ""}
                            name={"CPH"}
                            value={inputs["CPH"] ? inputs["CPH"] : ""}
                            handleErrors={handleErrors}
                            title={'Cases Per Hour'}
                            required={true}
                            onChange={(data, name) => handleChange(data, name)}
                        />
                        <CustomFieldWithTtileSS
                            type={"number"}
                            showError={dirty["PPH"] && errors["PPH"][0] ? errors["PPH"] : ""}
                            name={"PPH"}
                            value={inputs["PPH"] ? inputs["PPH"] : ""}
                            handleErrors={handleErrors}
                            title={'Pallets Per Hour'}
                            required={true}
                            onChange={(data, name) => handleChange(data, name)}
                        />
                    </>
                }
                <div className='checkbox-group'>
                    <label>Operational days <span className='color-red'>*</span></label>
                    <div className='flex-wrap'>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='sunday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.sunday} />
                            <span>Sunday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='monday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.monday} />
                            <span>Monday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='tuesday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.tuesday} />
                            <span>Tuesday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='wednesday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.wednesday} />
                            <span>Wednesday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='thursday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.thursday} />
                            <span>Thursday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='friday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.friday} />
                            <span>Friday</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <input type='checkbox' name='saturday' value={true} onChange={handleOperationalDays} checked={inputs?.operational_days?.saturday} />
                            <span>Saturday</span>
                        </div>
                    </div>
                </div>
                {dirty['operational_days'] && errors['operational_days'] ?

                    <span className="errorMessage">
                        {errors['operational_days']}
                    </span> : ''

                }
                <div className='d-flex gap-2'>
                    <div className='flex-fill'>
                        <CustomFieldWithTtileSS
                            type={"custom-time-selector"}
                            showError={
                                dirty["StartTime"] && errors["StartTime"][0]
                                    ? errors["StartTime"]
                                    : ""
                            }
                            name={"StartTime"}
                            customDatePickerConfig={{
                                selectedDate: "",
                                name: "StartTime",
                                timeFormat: 'HH:mm',
                                showTimeSelect: true,
                                showTimeSelectOnly: true,
                                timeIntervals: 15,
                                timeCaption: "Time",
                                customInput: (
                                    <TUSDatePickerInput
                                        value={startTimeState}
                                        titleField={"Start"}
                                    />
                                ),
                            }}
                            value={inputs.StartTime ? inputs.StartTime : ""}
                            handleErrors={handleErrors}
                            title={
                                AppConstant.smartScheduler.breaksForm.tableHeaders.startTime
                            }
                            required={true}
                            onChange={(data, name) => handleChange(data, name)}
                        />
                    </div>
                    <div className='flex-fill'>
                        <CustomFieldWithTtileSS
                            type={"custom-time-selector"}
                            showError={
                                dirty["EndTime"] && errors["EndTime"][0]
                                    ? errors["EndTime"]
                                    : ""
                            }
                            name={"EndTime"}
                            timeSlotStart={inputs.StartTime}
                            customDatePickerConfig={{
                                placeholder: "HH:MM",
                                selectedDate: "",
                                timeFormat: 'HH:mm',
                                startDate: "",
                                name: "EndTime",
                                showTimeSelect: true,
                                showTimeSelectOnly: true,
                                timeIntervals: 15,
                                timeCaption: "Time",
                                filterPassedTime: filterPassedTimeValue,
                                customInput: (
                                    <TUSDatePickerInput value={endTimeState} titleField={"End"} />
                                ),
                            }}
                            value={inputs.EndTime ? inputs.EndTime : ""}
                            handleErrors={handleErrors}
                            title={AppConstant.smartScheduler.breaksForm.tableHeaders.endTime}
                            required={true}
                            onChange={(data, name) => handleChange(data, name)}
                        />
                    </div>
                </div>
                <CustomFieldWithTtileSS
                    type={"select"}
                    showError={
                        dirty["ApptFrequency"] && errors["ApptFrequency"][0]
                            ? errors["ApptFrequency"]
                            : ""
                    }
                    name={"ApptFrequency"}
                    value={inputs["ApptFrequency"] ? inputs["ApptFrequency"] : ""}
                    handleErrors={handleErrors}
                    title={"Appointment Frequency (In min)"}
                    required={true}
                    onChange={(data, name) => handleChange(data, name)}
                    listData={getDockApptFrequency}
                    // disabledField={false}
                />
                <ColorPickerField />
                <CustomFieldWithTtileSS
                    type={"number"}
                    showError={dirty["BlockHours"] && errors["BlockHours"][0] ? errors["BlockHours"] : ""}
                    name={"BlockHours"}
                    value={inputs["BlockHours"] ? inputs["BlockHours"] : ""}
                    handleErrors={handleErrors}
                    title={<span>Block Time (In min) <i class="fa fa-info-circle" aria-hidden="true" data-for="dock-block-time-info-tooltip" data-tip={("dock-block-time-info-tooltip")}></i></span>}
                    required={false}
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    name="OverdueBookingAllowed"
                    type={"radio"}
                    showError={dirty["OverdueBookingAllowed"] && errors["OverdueBookingAllowed"][0] ? errors["OverdueBookingAllowed"] : ""}
                    required={true}
                    title={<span>Schedule Outside(Post) Window Allowed <i class="fa fa-info-circle" aria-hidden="true" data-for="schedule-outside-window-tooltip" data-tip="schedule-outside-window-tooltip"></i></span>}
                    value={String(inputs['OverdueBookingAllowed'] ?? false)}
                    radiconfig={[{
                        label: "Yes",
                        value: "true"
                    },
                    {
                        label: "No",
                        value: "false"
                    }]}
                    className="col-sm-12 mt-2 radioButtonText"
                    onChange={(data, name) => handleChange(data, name)}
                />
                {inputs.OverdueBookingAllowed && (
                    <CustomFieldWithTtileSS
                        name="ScheduleOutsideWindow"
                        type="number"
                        showError={dirty["ScheduleOutsideWindow"] && errors["ScheduleOutsideWindow"] ? errors["ScheduleOutsideWindow"] : ""}
                        required={true}
                        title={<span>Schedule Outside(Post) Window (in days)</span>}
                        value={inputs['ScheduleOutsideWindow']}
                        onChange={(data, name) => handleChange(data, name)}
                        handleErrors={handleErrors}
                    />
                )}
                <CustomTooltip
                    id={'schedule-outside-window-tooltip'}
                    title="Number of days an appointment can be created after the due date"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true}
                />
                <CustomTooltip
                    id={'dock-block-time-info-tooltip'}
                    title="Block time is the hours post which a carrier can book their appointment at a dock level"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomFieldWithTtileSS
                    type={"number"}
                    showError={dirty["appointmentLifeTime"] && errors["appointmentLifeTime"][0] ? errors["appointmentLifeTime"] : ""}
                    name={"appointmentLifeTime"}
                    value={inputs.appointmentLifeTime ?? ""}
                    handleErrors={handleErrors}
                    title={<span>Appointment Life Time (in hours) must be equal to Schedule Outside Window <i class="fa fa-info-circle" aria-hidden="true" data-for="dock-apt-life-time-info-tooltip" data-tip={("dock-apt-life-time-info-tooltip")}></i></span>}
                    placeHolder="Default is Zero hours"
                    required={false}
                    disabledField={true}
                />
                <CustomFieldWithTtileSS
                    type={"number"}
                    showError={dirty["appointmentLeadTime"] && errors["appointmentLeadTime"][0] ? errors["appointmentLeadTime"] : ""}
                    name={"appointmentLeadTime"}
                    value={inputs["appointmentLeadTime"] ? inputs["appointmentLeadTime"] : ""}
                    handleErrors={handleErrors}
                    title={<span>Appointment Lead Time (in hours) <i class="fa fa-info-circle" aria-hidden="true" data-for="dock-appt-lead-time-info-tooltip" data-tip={("dock-appt-lead-time-info-tooltip")}></i></span>}
                    placeHolder="Default is Zero hours"
                    required={false}
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    type={"number"}
                    showError={dirty["showReasonCodeWindow"] && errors["showReasonCodeWindow"][0] ? errors["showReasonCodeWindow"] : ""}
                    name={"showReasonCodeWindow"}
                    value={inputs["showReasonCodeWindow"] ? inputs["showReasonCodeWindow"] : ""}
                    handleErrors={handleErrors}
                    title={<span>Show Reason Code Window Before DueDate (in days) <i class="fa fa-info-circle" aria-hidden="true" data-for="showReasonCodeWindow-info-tooltip" data-tip={("showReasonCodeWindow-info-tooltip")}></i></span>}
                    placeHolder="Default is Zero days"
                    required={false}
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    type={"number"}
                    showError={dirty["showReasonCodeWindowPost"] && errors["showReasonCodeWindowPost"][0] ? errors["showReasonCodeWindowPost"] : ""}
                    name={"showReasonCodeWindowPost"}
                    value={inputs["showReasonCodeWindowPost"] ? inputs["showReasonCodeWindowPost"] : ""}
                    handleErrors={handleErrors}
                    title={<span>Show Reason Code Window After DueDate (in days) <i class="fa fa-info-circle" aria-hidden="true" data-for="showReasonCodeWindowPost-info-tooltip" data-tip={("showReasonCodeWindowPost-info-tooltip")}></i></span>}
                    placeHolder="Default is Zero days"
                    required={false}
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    name="NoShowAllowedStatus"
                    type={"radio"}
                    showError={dirty["NoShowAllowedStatus"] && errors["NoShowAllowedStatus"][0] ? errors["NoShowAllowedStatus"] : ""}
                    required={false}
                    title={<span>No Show Allowed <i class="fa fa-info-circle" aria-hidden="true" data-for="no-show-info-tooltip" data-tip={("no-show-info-tooltip")}></i></span>}
                    value={String(inputs['NoShowAllowedStatus'] ?? false)}
                    radiconfig={[{
                        label: "Yes",
                        value: "true"
                    },
                    {
                        label: "No",
                        value: "false"
                    }]}
                    className="col-sm-12 mt-2 radioButtonText"
                    onChange={(data, name) => handleChange(data, name)}
                />
                {inputs.NoShowAllowedStatus && (
                    <CustomFieldWithTtileSS
                        type={"number"}
                        showError={dirty["NoShowHours"] && errors["NoShowHours"][0] ? errors["NoShowHours"] : ""}
                        name={"NoShowHours"}
                        value={inputs["NoShowHours"] ? inputs["NoShowHours"] : ""}
                        handleErrors={handleErrors}
                        title={<span>No Show Hours <i class="fa fa-info-circle" aria-hidden="true" data-for="no-show-info-tooltip" data-tip={("no-show-info-tooltip")}></i></span>}
                        required={true}
                        onChange={(data, name) => handleChange(data, name)}
                    />
                )}
                <CustomTooltip
                    id={'dock-apt-life-time-info-tooltip'}
                    title="By default all appointments expire Midnight of the Appointment date"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomFieldWithTtileSS
                    name="DockAppointmentCompletionConfig"
                    type={"radio"}
                    showError={dirty["DockAppointmentCompletionConfig"] && errors["DockAppointmentCompletionConfig"][0] ? errors["DockAppointmentCompletionConfig"] : ""}
                    required={true}
                    title={<span>Complete appointment type <i class="fa fa-info-circle" aria-hidden="true" data-for="complete-appointment-type-tooltip" data-tip="complete-appointment-type-tooltip"></i></span>}
                    value={inputs['DockAppointmentCompletionConfig'] || 'AUTOMATIC'}
                    radiconfig={ [{
                        label: "Automatic",
                        value: "AUTOMATIC"
                    },
                    {
                        label: "Manual",
                        value: "MANUAL"
                        }]}
                        
                    className="col-sm-12 mt-2 radioButtonText"
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    name="AppointmentCancelationType"
                    type={"radio"}
                    showError={dirty["AppointmentCancelationType"] && errors["AppointmentCancelationType"][0] ? errors["AppointmentCancelationType"] : ""}
                    required={true}
                    title={<span>Mass Appointment Cancellation <i class="fa fa-info-circle" aria-hidden="true" data-for="mass-appointment-cancellation-tooltip" data-tip="mass-appointment-cancellation-tooltip"></i></span>}
                    value={inputs['AppointmentCancelationType'] || 'MANUAL'}
                    radiconfig={[{
                        label: "Automatic",
                        value: "AUTOMATIC"
                    },
                    {
                        label: "Manual",
                        value: "MANUAL"
                    }]}
            
                    className="col-sm-12 mt-2 radioButtonText"
                    onChange={(data, name) => handleChange(data, name)}
                />
                <CustomFieldWithTtileSS
                    name="AppointmentDueDateType"
                    type={"radio"}
                    showError={dirty["AppointmentDueDateType"] && errors["AppointmentDueDateType"][0] ? errors["AppointmentDueDateType"] : ""}
                    required={true}
                    title={<span>Appointment Due Date <i class="fa fa-info-circle" aria-hidden="true" data-for="appointment-due-date-tooltip" data-tip="appointment-due-date-tooltip"></i></span>}
                    value={inputs['AppointmentDueDateType'] || 'PARENTPO'}
                    radiconfig={[{
                        label: "Parent PO",
                        value: "PARENTPO"
                    },
                    {
                        label: "Earliest",
                        value: "EARLIEST"
                    }]}
            
                    className="col-sm-12 mt-2 radioButtonText"
                    onChange={(data, name) => handleChange(data, name)}
                />
            
                <CustomTooltip
                    id={'dock-appt-lead-time-info-tooltip'}
                    title="Appointment lead time is the number of hours a user can start booking an appointment before the due date"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                     <CustomTooltip
                    id={'showReasonCodeWindow-info-tooltip'}
                    title="Number of days reason code should show before due date"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomTooltip
                    id={'showReasonCodeWindowPost-info-tooltip'}
                    title="Number of days reason code should show after due date"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                 <CustomTooltip
                    id={'no-show-info-tooltip'}
                    title="Appointments that are not checked in should be marked as No Show."
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomTooltip
                    id={'complete-appointment-type-tooltip'}
                    title="Determines whether appointments are completed automatically or require manual completion"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomTooltip
                    id={'mass-appointment-cancellation-tooltip'}
                    title="Defines whether mass appointment cancellations are handled automatically or manually"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <CustomTooltip
                    id={'appointment-due-date-tooltip'}
                    title="Sets the due date based on Parent PO or the Earliest date available"
                    position='top'
                    type={themeSelected === AppConstant.commonStrings.lightModeFilterString ? 'dark' : 'light'}
                    multiline={true} />
                <div className="d-flex justify-content-end my-2">
                    <CustomButtonSS
                        isLoading={false}
                        title={"Reset"}
                        className={"btn-unstyled"}
                        onClick={() => setInputs({})}
                    />
                    <CustomButtonSS
                        isLoading={loading}
                        title={"Save"}
                        className={"btn-styled"}
                        onClick={submitForm}
                    />
                </div>
            </div>
        );
    };

    const createPayload = (data, type) => {
        if (type === "Edit") {
            return {
                "DockName": data.DockName,
                "PPH": data.PPH,
                "DockStatus": data.DockStatus,
                "ID": data.ID,
                "CRUDTYPE": "U",
                "IDWarehouse": data.IDWarehouse,
                "StartTime": data.StartTime,
                "EndTime": data.EndTime,
                "UpdatedBy": cu_id,
                "CreatedBy": cu_id,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "NonOperationalDays": unSlectedDays.length ? unSlectedDays.slice(1) : null
            }
        }
        else {
            return {
                "DockName": data.DockName,
                "PPH": data.PPH,
                "DockStatus": true,
                "ID": data.ID,
                "CRUDTYPE": "I",
                "IDWarehouse": whObj.ID,
                "StartTime": data.StartTime,
                "EndTime": data.EndTime,
                "CreatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "CreatedBy": cu_id,
                "UpdatedBy": cu_id,
                "UpdatedOn": changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
            }
        }
    }

    const getSummitedFormData = (data) => {
        setLoading(true);
        let apiParams = {}
        const operationObj = {
            type: '',
            status: '',
        }

        if (data.IDWarehouse) {
            const apiTempParams = createPayload(data, "Edit")
            operationObj.type = 'Edit Dock'
            apiParams = { ...data, ...apiTempParams }
            apiParams.StartTime = apiTempParams.StartTime;
            apiParams.EndTime = apiTempParams.EndTime
        }
        else {
            apiParams = createPayload(data, "Create")
            operationObj.type = 'Create Dock'
        }

        apiParams.StartTime = getDockOperationalTime(data?.StartTime);
        apiParams.EndTime = getDockOperationalTime(data?.EndTime);
        apiParams.operational_days = data.operational_days;
        apiParams.BlockHours = data.BlockHours ? data.BlockHours : null;
        apiParams.CapacityModeling = data?.CapacityModeling;
        apiParams.TPH = data?.TPH;
        apiParams.CPH = data?.CPH;
        apiParams.TPM = data?.TPM;
        apiParams.appointmentLifeTime = data?.appointmentLifeTime || 0;
        apiParams.appointmentLeadTime = data?.appointmentLeadTime || 0;
        apiParams.ShowReasonCodeWindow = data?.showReasonCodeWindow || 0;
        apiParams.ShowReasonCodeWindowPost = data?.showReasonCodeWindowPost || 0;
        apiParams.NoShowAllowedStatus = data?.NoShowAllowedStatus || false;
        apiParams.NoShowHours = apiParams.NoShowAllowedStatus ? (data?.NoShowHours || 0) : 0;
        apiParams.ApptFrequency = data?.ApptFrequency || 15
        apiParams.DockAppointmentCompletionConfig = data?.DockAppointmentCompletionConfig || 'AUTOMATIC'
        apiParams.AppointmentCancelationType = data?.AppointmentCancelationType || 'MANUAL'
        apiParams.AppointmentDueDateType = data?.AppointmentDueDateType || 'PARENTPO'
        apiParams.OverdueBookingAllowed = data?.OverdueBookingAllowed || false;
        apiParams.OverdueBookingAllowedDays = apiParams.OverdueBookingAllowed ? parseInt(data?.ScheduleOutsideWindow || 0) : 0;
        apiParams.DockColorCode = data?.DockColorCode || null;
        
        delete apiParams.ScheduleOutsideWindow

        // Store pendingDockData BEFORE dispatching so the preCheckList useEffect
        // can correctly resolve AppointmentCancelationType (including AUTOMATIC)
        // even when triggered by the edit/save flow (not just disable/delete).
        setPendingDockData({ apiParams, operationObj });

        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj })
    };

    /**
     * Function to validate operational days 
     * @param {*} data 
     * @returns 
     */
    const validateOperationalDays = (data) => {
        let valid = false;
        Object?.keys(data)?.forEach((el) => {
            if (data[el] === true) {
                valid = true
            }

        })
        return valid
    }

    /**
     * Function to handle form submit
     */
    const submitForm = () => {
        let dirtyData = dirty;
        Object.keys(dirty).forEach((control) => {
            dirtyData[control] = true;
        });


        setDirty(dirtyData);
        if (validate()) {

            getSummitedFormData(inputs);
        }
    };

    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };

    const submitbtnData = {
        show: true,
        text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
            .saveButtonTitle,
    };

    const showCreateDockPopup = () => {
        const popupObj = {
            id: 'createCompanyGroupFormPopup1',
            modalLabel: 'createCompanyGroupFormPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: !Object.keys(editData).length ? AppConstant.smartScheduler.docks.createDockTitle : AppConstant.smartScheduler.docks.editDockTitle,
            bodyText: createForm(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />
    }

    const closeCurrentpopup = () => {
        setEditData({});
        setErrors(initialErrors)
        setShowModal(false);
    }

    
    const openCreateForm = () => {
        setDirty({
        DockName: false,
        PPH: false,
        CPH: false,
        TPH: false,
        TPM: false,
        operational_days: false,
        StartTime: false,
        EndTime: false,
        CapacityModeling: false,
        BlockHours: false,
        appointmentLifeTime: false,
        appointmentLeadTime: false,
        showReasonCodeWindow: false,
        showReasonCodeWindowPost: false,
        ApptFrequency: false,
        AppointmentCancelationType: false,
        AppointmentDueDateType: false,
        ScheduleOutsideWindow: false,
        OverdueBookingAllowed: false,
        DockColorCode: false,
        NoShowAllowedStatus: false,
        NoShowHours: false
    })
    setShowModal(true);
    setEditData({});
        setInputs({})
        setErrors(initialErrors)
        setParticularFieldValue({});
    }
    const closePreCheckpopup = () => {
        setShowPreCheckModal(false)
    }

    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.viewDetailsStr) {
            navigate("/manageappointments")
        }
        else {
            setShowPreCheckModal(false)
        }
    }

    const showPreCheck = () => {
        const popupObj = {
            id: 'adminUpdateOperationPreCheck',
            modalLabel: 'adminUpdateOperationPreCheck',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.smartScheduler.docks.editDockTitle,
            bodyText: AppConstant.superUserAdmin.warehouseAdmin.preCheckBockerMsg,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.viewDetailsStr
                },
                btn2: {
                    show: false,
                    text: AppConstant.commonStrings.close
                },

            },
        }

        return <SSPopup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text) }} closepopup={() => { closePreCheckpopup() }} themeSelected={themeSelected} showModal={showPreCheckModal} />
    }

    const handleDisableOrDeleteDockWithPreCheck = (apiParams, operationObj) => {
        setPendingDockData({ apiParams, operationObj });
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    }

    const handleAutomaticCancelConfirm = (selectedReason, excludedAppointments) => {
        setLoading(true);
        const { apiParams, operationObj } = pendingDockData;
        // If selectedReason is null, all appointments were excluded - skip cancellation, still save the dock change
        const allExcluded = !selectedReason;
        const newApiParams = {
            ...apiParams,
            ConflictAptStatus: !allExcluded,
            // Retain the original AppointmentCancelationType when all are excluded (do not null it out)
            AppointmentCancelationType: allExcluded ? apiParams.AppointmentCancelationType : 'AUTOMATIC',
            Reason: allExcluded ? null : selectedReason,
            ExcludedAppointments: !allExcluded && excludedAppointments && excludedAppointments.length ? excludedAppointments.toString() : null
        };
        // When all appointments are excluded, mark confirm=true so the saga skips the pre-check
        // and proceeds directly to saving the dock change (avoids re-triggering the popup).
        const newOperationObj = allExcluded ? { ...operationObj, confirm: true } : operationObj;
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: newApiParams, operationObj: newOperationObj });
        if (!allExcluded) {
            setShowAutoMassCancelNotification(true);
        }
        setPendingDockData(null);
    }

    const showAutomaticCancelPopup = () => {
        if (!showAutomaticCancelConfirmPopup) return null;

        const popupBodyText = `You are trying to make changes to a dock that has appointments scheduled. This action will cancel all conflicting appointments.`;

        return (
            <AutomaticCancelPopup
                themeSelected={themeSelected}
                showPopup={showAutomaticCancelConfirmPopup}
                setShowPopup={setShowAutomaticCancelConfirmPopup}
                pendingData={pendingDockData}
                setPendingData={setPendingDockData}
                whObj={whObj}
                onProceed={handleAutomaticCancelConfirm}
                popupTitle="Confirm Dock Change"
                popupBodyText={popupBodyText}
                cuid={cu_id}
                showCheckboxes={true}
            />
        )
    }

    return (
        <div>
            <div className='container-fluid d-flex py-2 text-start justify-content-between mt-1'>
                <button
                    className={'btn-highlighted f-12 me-3'}
                    data-bs-toggle="modal"
                    onClick={() => openCreateForm()}>
                    {AppConstant.smartScheduler.docks.createDockTitle}
                </button>
                <div className='ms-5'>
                    <WarehouseSearchSS
                        placeholder={'Search Docks'}
                        inputValue={searchStr}
                        cancelSearch={() => setSearchStr('')}
                        onChangeHandler={(text) => setSearchStr(text)} />
                </div>
            </div>
            <div className="d-flex justify-content-center metaDockList">
                <DockListSS searchStr={searchStr} editDockAction={(groupObj) => editDock(groupObj)} showPopup={() => showCreateDockPopup()} themeSelected={themeSelected} allowPermissionE={allowPermissionE} allowPermissionD={allowPermissionD} whObj={whObj} handleDisableOrDeleteDockWithPreCheck={handleDisableOrDeleteDockWithPreCheck} whMetaDocksList={whMetaDocksList} />
                {showCreateDockPopup()}
                {showPreCheck()}
                {showAutomaticCancelPopup()}
            </div>
        </div>

    )
}

export default DocksSS;